import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { AboutService } from './about.service';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent implements OnInit {

  aboutData: any ;

  constructor(
    private location: Location,
    public aboutService : AboutService
  ) { }

  ngOnInit() {
    this.aboutService.getAbout()
    .subscribe(data => {
      this.aboutData=data;
    });
  }

  goBack() {
    this.location.back();
  }

}
